export default {
  home: {
    sections: {
      trendingParlays: "Trending Parlays of the day",
    },
    checkout: {
      placeItOn: "Place it on",
    },
    matchups: {
      today: "Today's Matchups",
      thisWeek: "This Week's Matchups",
      upcoming: "Upcoming Matchups",
    },
    actions: {
      claimNow: "Claim Now",
      showMore: "Show more",
      showLess: "Show less",
    },
    empty: {
      parlayMinGames: "No trends available yet. Needs 3 games minimum.",
    },
    hundredPercentClub: {
      subtitle: "Props that hit in 100% of games",
    },
    advancedTools: {
      subtitles: {
        startingLineups: "Find value when starting lineups change. Included with",
        injuryImpact: "See how injuries impact teammates. Included with",
        opponentRank: "Exploit favourable defensive matchups. Included with",
        startingPitchers: "Target spots against vulnerable pitchers. Included with",
        weatherReport: "Use wind and weather to your advantage. Included with",
      },
    },
    predictionMarkets: {
      status: {
        loading: "Loading markets...",
        loadError: "Unable to load markets.",
      },
    },
    sidebar: {
      downloadApp: "Download the App",
      neverMissTrend: "Never Miss a Trend",
      unlockAnalysis: "Unlock the Full Analysis",
      unlock: "Unlock",
      mostBetOn: "Most bet on",
      mostSearched: "Most searched",
      trendingLeagues: "Trending leagues",
      topOffers: "Top {{type}}",
      newsletter: {
        title: "Stay ahead of the trends",
        description: "Join <strong>30,000+ sports bettors</strong> getting Linemate insights and offers in their inbox.",
        subscribe: "Subscribe",
        subscribedTitle: "You're subscribed!",
        subscribedBody: "We'll send the latest Linemate trends and offers to your inbox.",
      },
      improveExperience: "Improve your Linemate experience",
      getAccess: "GET ACCESS TO ADVANCED PLAYS & DEEPER INSIGHTS",
    },
  },
};
